export default "__VITE_ASSET__a87242fe__"